module.exports = __webpack_public_path__ + "static/media/nyttårsaften.5faa5dd7.m4a";